import { render, staticRenderFns } from "./biu-dialog.vue?vue&type=template&id=25a0f4a4&"
import script from "./biu-dialog.vue?vue&type=script&lang=ts&"
export * from "./biu-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./biu-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports